(function () {
    'use strict';

    angular.module("imApp").factory("acCustTransesAgeService", ['$ihttp', function ($ihttp) {
        let service = {
            getAcCustTransesAge: function (parms) {
                return $ihttp.post({
                    method: 2796,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
